import { Box } from '@mui/material'
import React from 'react'
import { PotentiallyHtml } from '../PotentiallyHtml'
import { TreeEditingContext } from './context'
import { SkillsView } from './SkillsView'
import { childNodesOfType } from '../utility/TreeHelpers'
import { NodeType } from 'shared/types/ingestion'

export function LessonPlanView({
  nodeId,
  treeId,
}: {
  nodeId: string
  treeId: string
}) {
  const { idMaps } = React.useContext(TreeEditingContext)
  const node = idMaps[treeId]?.[nodeId]
  if (!node) return null
  const skillsLists = childNodesOfType(node.node, NodeType.SkillsList)
  return (
    <Box>
      <Box>
        <PotentiallyHtml s={node.node.title} />
      </Box>
      <Box paddingTop={'5px'}>
        {skillsLists.map(({ id }) => (
          <SkillsView key={id} nodeId={id} treeId={treeId} />
        ))}
      </Box>
    </Box>
  )
}
